
export const FullPageLoader = () => (
    <div style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }}>
        <img src="./loading.svg" alt="Loading..." style={{ width: '80px', height: '80px' }} />
    </div>
);